/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-api
 * crm-screener-api
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { CriteriaTargetInput } from './CriteriaTargetInput';
import {
    CriteriaTargetInputFromJSON,
    CriteriaTargetInputFromJSONTyped,
    CriteriaTargetInputToJSON,
    CriteriaTargetInputToJSONTyped,
} from './CriteriaTargetInput';

/**
 * 
 * @export
 * @interface CreateCriteriaTargetsRequest
 */
export interface CreateCriteriaTargetsRequest {
    /**
     * 
     */
    criteria: CriteriaTargetInput;
    /**
     * 
     */
    facility_ids: Array<string>;
    /**
     * 
     */
    facility_system_tags: Array<string>;
    /**
     * 
     */
    facility_custom_tag_ids?: Array<string>;
}

/**
 * Check if a given object implements the CreateCriteriaTargetsRequest interface.
 */
export function instanceOfCreateCriteriaTargetsRequest(value: object): value is CreateCriteriaTargetsRequest {
    if (!('criteria' in value) || value['criteria'] === undefined) return false;
    if (!('facility_ids' in value) || value['facility_ids'] === undefined) return false;
    if (!('facility_system_tags' in value) || value['facility_system_tags'] === undefined) return false;
    return true;
}

export function CreateCriteriaTargetsRequestFromJSON(json: any): CreateCriteriaTargetsRequest {
    return CreateCriteriaTargetsRequestFromJSONTyped(json, false);
}

export function CreateCriteriaTargetsRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreateCriteriaTargetsRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'criteria': CriteriaTargetInputFromJSON(json['criteria']),
        'facility_ids': json['facility_ids'],
        'facility_system_tags': json['facility_system_tags'],
        'facility_custom_tag_ids': json['facility_custom_tag_ids'] == null ? undefined : json['facility_custom_tag_ids'],
    };
}

export function CreateCriteriaTargetsRequestToJSON(json: any): CreateCriteriaTargetsRequest {
    return CreateCriteriaTargetsRequestToJSONTyped(json, false);
}

export function CreateCriteriaTargetsRequestToJSONTyped(value?: CreateCriteriaTargetsRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'criteria': CriteriaTargetInputToJSON(value['criteria']),
        'facility_ids': value['facility_ids'],
        'facility_system_tags': value['facility_system_tags'],
        'facility_custom_tag_ids': value['facility_custom_tag_ids'],
    };
}

